var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-73.471H0V385.379z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M257.277,241.579l3.159,9.473l9.985,0.077c1.293,0.01,1.828,1.66,0.789,2.428l-8.033,5.932 l3.012,9.521c0.389,1.233-1.013,2.252-2.066,1.501L256,264.703l-8.124,5.806c-1.052,0.751-2.455-0.268-2.066-1.501l3.012-9.521 l-8.033-5.932c-1.039-0.768-0.504-2.418,0.789-2.428l9.985-0.077l3.159-9.473C255.133,240.352,256.867,240.352,257.277,241.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M167.104,267.002l3.159,9.473l9.985,0.077c1.293,0.01,1.828,1.66,0.789,2.428l-8.033,5.932 l3.012,9.521c0.39,1.233-1.013,2.252-2.066,1.501l-8.124-5.806l-8.124,5.806c-1.052,0.751-2.455-0.268-2.066-1.501l3.012-9.521 l-8.033-5.932c-1.041-0.768-0.504-2.418,0.789-2.428l9.985-0.077l3.159-9.473C164.96,265.775,166.695,265.775,167.104,267.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M167.104,216.156l3.159,9.473l9.985,0.077c1.293,0.01,1.828,1.66,0.789,2.428l-8.033,5.932 l3.012,9.521c0.39,1.233-1.013,2.252-2.066,1.501l-8.124-5.806l-8.124,5.806c-1.052,0.751-2.455-0.268-2.066-1.501l3.012-9.521 l-8.033-5.932c-1.041-0.768-0.504-2.418,0.789-2.428l9.985-0.077l3.159-9.473C164.96,214.929,166.695,214.929,167.104,216.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M347.448,267.002l3.159,9.473l9.985,0.077c1.293,0.01,1.828,1.66,0.789,2.428l-8.033,5.932 l3.012,9.521c0.389,1.233-1.013,2.252-2.066,1.501l-8.124-5.806l-8.124,5.806c-1.052,0.751-2.455-0.268-2.066-1.501l3.012-9.521 l-8.033-5.932c-1.041-0.768-0.504-2.418,0.789-2.428l9.985-0.077l3.159-9.473C345.305,265.775,347.04,265.775,347.448,267.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M347.448,216.156l3.159,9.473l9.985,0.077c1.293,0.01,1.828,1.66,0.789,2.428l-8.033,5.932 l3.012,9.521c0.389,1.233-1.013,2.252-2.066,1.501l-8.124-5.806l-8.124,5.806c-1.052,0.751-2.455-0.268-2.066-1.501l3.012-9.521 l-8.033-5.932c-1.041-0.768-0.504-2.418,0.789-2.428l9.985-0.077l3.159-9.473C345.305,214.929,347.04,214.929,347.448,216.156z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/hn.3a11d21f9ce57b8cb6a217ebba3a30f8.svg";
export { ForwardRef as ReactComponent };